import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

import site from "../../data/site.json";
import content from "../../data/content.json";

export const COMPANY = site.company;

export const NO_AFFILIATION = site.noAffiliation;

export const DISCLAIMER = content.footer.disclaimer;

const linkClass =
  "text-slate-200 underline decoration-slate-500 underline-offset-4 transition-colors duration-200 hover:text-emerald-400 hover:decoration-emerald-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 rounded-sm";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-slate-800 bg-slate-950">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <p data-testid="footer-disclaimer" className="max-w-3xl text-sm leading-relaxed text-slate-300">
          {DISCLAIMER}
        </p>
        <p data-testid="footer-no-affiliation" className="mt-3 max-w-3xl text-sm leading-relaxed text-slate-400">
          {NO_AFFILIATION}
        </p>
        <div className="mt-10 grid gap-8 border-t border-slate-800 pt-10 text-sm md:grid-cols-3">
          <div className="space-y-2">
            <p className="font-semibold text-slate-100">Institucional</p>
            <p data-testid="footer-razao-social" className="break-words text-slate-400">Razão Social: {COMPANY.razaoSocial}</p>
            <p data-testid="footer-nome-fantasia" className="text-slate-400">Nome Fantasia: {COMPANY.nomeFantasia}</p>
            <p data-testid="footer-cnpj" className="text-slate-400">CNPJ: {COMPANY.cnpj}</p>
            <p data-testid="footer-address" className="break-words text-slate-400">Endereço da sede operacional: {COMPANY.endereco}</p>
            <p className="text-slate-400">
              E-mail de contato e suporte:{" "}
              <a data-testid="footer-dpo-email" href="mailto:atelie@gepeto.life" className={linkClass}>
                atelie@gepeto.life
              </a>
            </p>
            <p><Link to="/sobre" data-testid="footer-link-sobre" className={linkClass}>Sobre</Link></p>
          </div>
          <div className="space-y-2">
            <p className="font-semibold text-slate-100">Conformidade LGPD</p>
            <p data-testid="footer-lgpd-note" className="flex gap-2 text-slate-400">
              <ShieldCheck aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
              {content.footer.lgpdNote}
            </p>
          </div>
          <div className="space-y-2">
            <p className="font-semibold text-slate-100">Documentos legais</p>
            <ul className="space-y-2">
              <li><Link to="/termos" data-testid="footer-link-termos" className={linkClass}>Termos de Uso</Link></li>
              <li><Link to="/privacidade" data-testid="footer-link-privacidade" className={linkClass}>Política de Privacidade</Link></li>
            </ul>
          </div>
        </div>
        <p data-testid="footer-copyright" className="mt-10 font-mono text-xs text-slate-500">
          © {year} Gepeto.life. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
